<template>
  <div>
    <div class="sc-apply-conditions-backdrop"></div>
    <div class="sc-apply-conditions-container">
      <div
        v-if="selectedCondition === contractConditionTypes.OTP_DATA_PASSING || selectedCondition === contractConditionTypes.RECURRING_PAYMENT"
        @click="onClose"
        class="sc-apply-conditions-close-button">
        <i class="sc-icon-cancel"/>
      </div>
      <div v-html="condition"></div>
      <div v-if="selectedCondition === contractConditionTypes.USER_TERMS">
        <div class="sc-apply-conditions-buttons-container">
          <div class="sc-apply-conditions-button">
            <rounded-button color="outline" @click="select(decision.denied)">
              <span>{{ $t('payment_page.deny') }}</span>
            </rounded-button>
          </div>
          <div class="sc-apply-conditions-button">
            <rounded-button color="primary" @click="select(decision.accepted)">
              <span>{{ $t('payment_page.accept') }}</span>
            </rounded-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContractConditionActions } from './../utils/ContractConditionActions'
import { ContractConditionTypes } from './../utils/ContractConditionTypes'
import RoundedButton from '../../shared/components/RoundedButton'

export default {
  name: 'ApplyConditions',
  components: { RoundedButton },
  props: {
    selectedCondition: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      decision: { accepted: true, denied: false },
      contractConditionTypes: ContractConditionTypes,
      condition: this.$t('templates.' + this.selectedCondition)
    }
  },
  methods: {
    select (isAccepted) {
      this.$emit(ContractConditionActions.SELECTED, isAccepted)
    },
    onClose () {
      this.$emit(ContractConditionActions.CLOSE)
    }
  }
}
</script>

<style scoped lang="scss">
.sc-apply-conditions-container {
  z-index: 9999;
  position: relative;
  border: 1px solid $sc-primary;
  background-color: white;
  width: 700px;
  height: 600px;
  overflow: auto;
  padding: 30px;
}
.sc-apply-conditions-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(224, 224, 224, 0.3);
  z-index: 9998;
}
.sc-apply-conditions-buttons-container {
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 20px;
}
.sc-apply-conditions-close-button {
  float: right;
  cursor: pointer;
  font-size: 30px;
  color: #bb3747;
}

@media(max-width: 768px) {
  .sc-apply-conditions-container{
    width: 100%;
    padding: 15px 5px 15px 0px;
  }
}
</style>
